import React from 'react';

export default function Disclaimer() {
  return (
    <div className="container" style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Disclaimer</h1>
      <p>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

      <h2>1. Natura del Servizio</h2>
      <p>VerificaIncentivi.it è una piattaforma informativa che fornisce un servizio di analisi automatizzata degli incentivi e delle agevolazioni potenzialmente disponibili per le imprese italiane. Il servizio si basa su dati pubblicamente accessibili e sulle informazioni fornite dall'utente.</p>

      <h2>2. Nessuna Garanzia di Risultato</h2>
      <p><strong>Il servizio offerto da VerificaIncentivi.it non garantisce in alcun modo che l'utente o la sua azienda riceveranno effettivamente gli incentivi, i contributi o le agevolazioni indicati nel report.</strong> I report generati dalla piattaforma rappresentano un'analisi preliminare basata sui dati disponibili al momento della generazione e non costituiscono alcuna promessa o garanzia di ottenimento dei benefici indicati.</p>

      <h2>3. Non Costituisce Consulenza Professionale</h2>
      <p>Le informazioni fornite tramite il sito e i report generati hanno esclusivamente carattere informativo e orientativo. <strong>Non costituiscono e non possono in alcun modo sostituire una consulenza professionale</strong> di tipo legale, fiscale, finanziario o di qualsiasi altra natura. Si consiglia sempre di rivolgersi a professionisti abilitati per una valutazione specifica della propria situazione.</p>

      <h2>4. Responsabilità dell'Utente</h2>
      <p><strong>È responsabilità esclusiva dell'utente verificare i requisiti di accesso agli incentivi presso le autorità competenti</strong>, gli enti erogatori e gli organismi preposti. L'utente è tenuto a verificare autonomamente la correttezza, la completezza e l'attualità delle informazioni contenute nei report prima di intraprendere qualsiasi azione o decisione.</p>

      <h2>5. Esclusione di Responsabilità</h2>
      <p>Consulentecrediti S.r.l.s. non sarà in alcun caso responsabile per:</p>
      <ul>
        <li>Mancato ottenimento di incentivi, contributi o agevolazioni.</li>
        <li>Decisioni prese dall'utente sulla base delle informazioni fornite dalla piattaforma.</li>
        <li>Eventuali errori, inesattezze o omissioni nelle informazioni fornite.</li>
        <li>Danni diretti, indiretti, incidentali, consequenziali o punitivi derivanti dall'utilizzo del servizio.</li>
        <li>Modifiche normative o regolamentari intervenute successivamente alla generazione del report.</li>
      </ul>

      <h2>6. Accuratezza delle Informazioni</h2>
      <p>Sebbene ci impegniamo a mantenere le informazioni il più aggiornate e accurate possibile, non possiamo garantire la completezza, l'esattezza o l'attualità di tutti i dati presenti sulla piattaforma. Le normative sugli incentivi sono soggette a frequenti modifiche da parte delle istituzioni competenti.</p>

      <h2>7. Link Esterni</h2>
      <p>Il sito può contenere link a siti web di terze parti. Consulentecrediti S.r.l.s. non è responsabile dei contenuti, delle politiche sulla privacy o delle pratiche di tali siti esterni.</p>

      <h2>8. Contatti</h2>
      <p>Per qualsiasi chiarimento relativo al presente Disclaimer, è possibile contattarci ai seguenti recapiti:</p>
      <ul>
        <li>Email: <a href="mailto:info@verificaincentivi.it">info@verificaincentivi.it</a></li>
        <li>PEC: <a href="mailto:consulentecrediti@legalmail.it">consulentecrediti@legalmail.it</a></li>
      </ul>
    </div>
  );
}
